module.exports = __webpack_public_path__ + "img/zhxy_image_12.02721cf2.png";